<template>
  <div class="mt-5">
    <b-row>
      <b-col cols="6">
        <h4>Terms & Conditions</h4>
        <div
          :class="[isVisible ? '' : '', 'border', 'p-4', 'text-left']"
          style="height: 340px; overflow-y: scroll; white-space:pre-wrap"
        >
          <small>{{ template }}</small>
        </div>
      </b-col>
      <b-col cols="6">
        <i class="auth-icon fa-solid fa-badge-check pb-2 text-success"></i>

        <b-row>
          <b-col>
            <div class="stat-box-title">Authorization</div>
            <div class="stat-box-body pb-3">
              Online<br />
              <small class="text-muted">{{ ipAddress }}</small>
            </div>
          </b-col>
          <b-col>
            <div class="stat-box-title">Date</div>
            <div class="stat-box-body pb-3">
              {{ approvedDate | moment("MM/DD/YYYY") }}<br />
              <small class="text-muted">{{
                approvedDate | moment("hh:mm:ss A")
              }}</small>
            </div>
          </b-col>
          <b-col>
            <div class="stat-box-title">Authorization</div>
            <div class="stat-box-body pb-3">{{ method }}<br /></div>
          </b-col>
        </b-row>

        <div class="stat-box-title pb-2">Signature</div>
        <div class="border width-100 p-4">
          <img :src="signature" style="height: 150px" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    method: null,
    ipAddress: null,
    signature: null,
    template: null,
    approvedDate: null,
  },
};
</script>

<style scoped>
.auth-icon {
  font-size: 1.6em;
  padding-top: 32px;
}
</style>
